import React, { createContext, useCallback, useEffect, useState, useMemo } from "react";
import { categoryFetcher } from "../api/requests";

const CategoryContext = createContext();

const CategoryContextProvider = ({ children }) => {
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);

  const updateCategories = useCallback((newData) => {
    setCategories(newData);
  }, []);

  const updateSubCategories = useCallback((newData) => {
    setSubCategories(newData);
  }, []);

  useEffect(() => {
    let isActive = true;

    const load = async () => {
      try {
        const [cats, subs] = await Promise.all([
          categoryFetcher.get(),
          categoryFetcher.getSub(),
        ]);

        if (!isActive) return;
        setCategories(cats?.results ?? []);
        setSubCategories(subs?.results ?? []);
      } catch (err) {
        console.error(err);
      }
    };

    load();
    return () => {
      isActive = false;
    };
  }, []);

  const contextValue = useMemo(() => ({
    categories,
    updateCategories,
    subCategories,
    updateSubCategories,
  }), [categories, subCategories])

  return (
    <CategoryContext.Provider value={contextValue}>
      {children}
    </CategoryContext.Provider>
  );
};

export { CategoryContext, CategoryContextProvider };
